/** Browser / SDK noise that should not page as a production client crash. */
export function isIgnorableClientRuntimeError(message: unknown): boolean {
  const text =
    typeof message === "string"
      ? message
      : message instanceof Error
        ? message.message
        : "";
  if (!text) return false;
  return /connection to indexed database server lost/i.test(text);
}
